import styled from 'styled-components';

export const Sentinel = styled.div`
  height: 1px;
  pointer-events: none;
`;

export const CompactTopbar = styled.div`
  position: fixed;
  top: 48px;
  z-index: 50;
  height: 65px;
  min-height: 65px;
  width: ${(p) => (p.$containerWidth != null ? `${p.$containerWidth}px` : '100%')};
  left: ${(p) => (p.$containerLeft != null ? `${p.$containerLeft}px` : 'auto')};
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(255, 255, 255, 0.98) calc(100% - 10px),
    rgba(255, 255, 255, 0.4) 100%
  );
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  transform: translateY(${(p) => (p.$show ? '0' : '-100%')});
  opacity: ${(p) => (p.$show ? 1 : 0)};
  transition: transform 120ms ease-out, opacity 120ms ease-out;
  will-change: transform, opacity;
  pointer-events: ${(p) => (p.$show ? 'auto' : 'none')};
`;

export const CompactTopbarInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 ${(p) => p.theme?.spacing?.xxl ?? '24px'};
  gap: 16px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0px 24px 24px 24px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const TitleBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

export const ButtonWrapper = styled.div`
  flex-shrink: 0;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
